import { axios, createFormData, handleError } from '../axios';

export const memberEventSeen = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/events/seen/item', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
